import type { Time } from 'lightweight-charts';
import type { TechnicalIndicatorData } from '../api/metrics';

export type IchimokuMetricType =
  | 'TENKAN_SEN'
  | 'KIJUN_SEN'
  | 'SENKOU_SPAN_A'
  | 'SENKOU_SPAN_B'
  | 'CHIKOU_SPAN';

export const ICHIMOKU_DISPLACEMENT_CANDLES = 26;

export interface DisplacedPoint {
  time: Time;
  value: number;
}

function displacementSeconds(metricType: IchimokuMetricType, granularityMins: number): number {
  switch (metricType) {
    case 'SENKOU_SPAN_A':
    case 'SENKOU_SPAN_B':
      return ICHIMOKU_DISPLACEMENT_CANDLES * granularityMins * 60;
    case 'CHIKOU_SPAN':
      return -ICHIMOKU_DISPLACEMENT_CANDLES * granularityMins * 60;
    case 'TENKAN_SEN':
    case 'KIJUN_SEN':
      return 0;
  }
}

export function applyIchimokuDisplacement(
  rows: TechnicalIndicatorData[],
  metricType: IchimokuMetricType,
  granularityMins: number,
): DisplacedPoint[] {
  const shift = displacementSeconds(metricType, granularityMins);
  return rows.map((row) => {
    const baseSeconds = Math.floor(new Date(row.metricTime).getTime() / 1000);
    return {
      time: (baseSeconds + shift) as Time,
      value: row.value,
    };
  });
}
